import _ from 'lodash';

export const getCustomCheckoutMessage = (isFlagEnabled, dispensary, orderType) => {
  if (!isFlagEnabled || !dispensary || !orderType) {
    return null;
  }

  const { orderTypesConfigV2 } = dispensary;
  const formattedOrderType = orderType === 'pickup' ? 'inStorePickup' : orderType;

  return orderTypesConfigV2?.[formattedOrderType]?.checkoutMessage ?? null;
};
